const doc = [({"reverse_charge":"\nLe destinataire du service est redevable de la TVA selon le mécanisme d'autoliquidation. "})];
module.exports = doc.length <= 1 ? doc[0] : doc;